import React from 'react'
import { formatDbDateWithoutTime } from '../../utils/dateFormater'
import { Link } from 'react-router-dom'
import Img2 from "../images/products-image.png"

const Products = ({ products, user }) => {

    const handleClassName = (ProductStatus) => {
        if (ProductStatus === "ACTIVE") return "text-emerald-700 bg-emerald-50 border-emerald-200/50";
        if (ProductStatus === "SYSTEM_CANCELLED") return "text-rose-700 bg-rose-50 border-rose-200/50";
        if (ProductStatus === "SUSPENDED") return "text-amber-700 bg-amber-50 border-amber-200/50";
        if (ProductStatus === "INACTIVE") return "text-zinc-700 bg-zinc-50 border-zinc-200/50";
        if (ProductStatus === "PAUSED") return "text-amber-700 bg-amber-50 border-amber-200/50";
        return "text-zinc-700 bg-zinc-50 border-zinc-200/50";
    }

    const getStatusIcon = (status) => {
        if (status === "ACTIVE") return "fa-check-circle";
        if (status === "SYSTEM_CANCELLED") return "fa-xmark-circle";
        if (status === "SUSPENDED") return "fa-ban";
        if (status === "INACTIVE") return "fa-eye-slash";
        if (status === "PAUSED") return "fa-pause-circle";
        return "fa-circle";
    }

    return (
        <div className="bg-white rounded-2xl p-6 lg:p-8">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-md shadow-indigo-500/20">
                        <i className="fa-solid fa-box-open text-white text-xl"></i>
                    </div>
                    <div>
                        <h2 className="text-xl font-bold text-zinc-900">Recent Products</h2>
                        <p className="text-sm text-zinc-500 mt-0.5">Here is the list of your 5 most recent products.</p>
                    </div>
                </div>
                
                <div className="flex items-center gap-4 self-stretch md:self-auto justify-between md:justify-end">
                    <img src={Img2} alt="" className="h-10 object-contain hidden md:block" />
                    <Link to={`/products/all-products`} className="inline-flex items-center gap-2 bg-white border border-zinc-200 hover:border-zinc-300 shadow-sm hover:shadow-md transition-all px-4 py-2.5 rounded-xl text-sm font-bold text-zinc-700 group">
                        View All Products
                        <i className="fa-solid fa-arrow-right text-zinc-400 group-hover:translate-x-1 transition-transform"></i>
                    </Link>
                </div>
            </div>

            {/* Table */}
            <div className="w-full overflow-x-auto border border-zinc-100 rounded-xl">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-zinc-50/50">
                            <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider w-12 whitespace-nowrap"></th>
                            <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider whitespace-nowrap">Product ID</th>
                            <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider whitespace-nowrap">Status</th>
                            <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider text-center whitespace-nowrap">PM Commission</th>
                            {user?.role !== "PM" && (
                                <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider text-center whitespace-nowrap">Portal Commission</th>
                            )}
                            <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider text-center whitespace-nowrap">Orders Limit</th>
                            <th className="px-4 py-4 text-xs font-bold text-zinc-500 uppercase tracking-wider text-right whitespace-nowrap">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products?.length > 0 ? (
                            products.map((product, index) => (
                                <tr key={index} className="border-t border-zinc-100 hover:bg-zinc-50/30 transition-colors">
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${handleClassName(product?.status)} border`}>
                                            <i className="fa-solid fa-bag-shopping text-sm"></i>
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 text-sm font-medium text-zinc-900 whitespace-nowrap">
                                        {product?.id}
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold border ${handleClassName(product?.status)} whitespace-nowrap`}>
                                            <i className={`fa-solid ${getStatusIcon(product?.status)}`}></i>
                                            {product?.status.replaceAll("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                                        </span>
                                    </td>
                                    <td className="px-4 py-4 text-sm font-bold text-zinc-900 text-center whitespace-nowrap">
                                        Rs. {product?.pm_commission || 0}
                                    </td>
                                    {user?.role !== "PM" && (
                                        <td className="px-4 py-4 text-sm font-bold text-zinc-900 text-center whitespace-nowrap">
                                            Rs. {product?.portal_commission || 0}
                                        </td>
                                    )}
                                    <td className="px-4 py-4 text-sm font-bold text-zinc-500 text-center whitespace-nowrap">
                                        {product?.today_limt_left || 0}
                                    </td>
                                    <td className="px-4 py-4 text-sm font-medium text-zinc-500 text-right whitespace-nowrap">
                                        {formatDbDateWithoutTime(product?.created_at)}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={user?.role !== "PM" ? 7 : 6} className="px-4 py-8 text-center text-sm text-zinc-500 font-medium whitespace-nowrap">
                                    No Record Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Products
